<h4 class="modal-title">ORDER SCHEDULE DETAILS</h4>
<div class="d-flex justify-content-between align-items-center mb-2">
  <h5 class="modal-title">HEADER NOTES</h5>
  <button (click)="openAddEdit()"><mat-icon>edit</mat-icon></button>
</div>

<div *ngIf="allAttachments?.length > 0 && displayNoteGrid">
  <table class="table table-striped table-bordered w-100">
    <thead>
      <tr>
        <!-- <th *ngIf="!isReadOnly" scope="col" class="text-uppercase">
          <label>ACTION</label>
        </th> -->
        <th scope="col" class="text-uppercase">
          <label>TYPE</label>
        </th>
        <th scope="col" class="text-uppercase w-100">
          <label>DATA</label>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of allAttachments">
        <!-- <td *ngIf="!isReadOnly" class="text-center d-flex">
          <mat-icon (click)="deleteItem(item)">delete</mat-icon>
          <span class="px-1"></span>
          <mat-icon (click)="editNote(item)" *ngIf="item.type !== ORDER_ATTACHMENT_TYPE.file">edit</mat-icon>
        </td> -->
        <td class="text-center text-capitalize">
          {{ item.type }}
        </td>
        <td *ngIf="item.type === ORDER_ATTACHMENT_TYPE.link">
          <label
            >LAST CHANGED BY: {{ item.lastChangeUser }}
            {{ item.lastChangeDate }}
            {{ formatTime(item.lastChangeTime) }}</label
          >
          <div>
            <a [href]="item.data" target="_blank">{{ item.data }}</a>
          </div>
        </td>
        <td *ngIf="item.type === ORDER_ATTACHMENT_TYPE.note">
          <label
            >LAST CHANGED BY: {{ item.lastChangeUser }}
            {{ item.lastChangeDate }}
            {{ formatTime(item.lastChangeTime) }}</label
          >
          <div [innerHTML]="item.data"></div>
        </td>
        <td *ngIf="item.type === ORDER_ATTACHMENT_TYPE.file">
          <label
            >LAST CHANGED BY: {{ item.lastChangeUser }}
            {{ item.lastChangeDate }}
            {{ formatTime(item.lastChangeTime) }}</label
          >
          <div>
            <a href="javascript:void(0)" (click)="downloadFile(item)">{{ item.name }}</a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
